module.exports = __webpack_public_path__ + "img/GALAWERSEbg.7258a62c.png";